import moment from 'moment';
import {PaxNodeFields} from './types';
import {PaxNodeInput} from '__generated__/graphql/types';

type CheckInPassengerState = Pick<PaxNodeFields, 'checkInType' | 'nodeState' | 'finalizationReasonType'>;

export const CHECK_IN_PERMISSION = 'flytsuite.live.passenger.checkin';

export function isCheckedInPassenger(passenger: CheckInPassengerState): boolean {
    return ['CSR', 'KIOSK', 'LOCKED', 'DEPARTED'].includes(passenger.checkInType || '');
}

export function getCheckInTimeDisabledReason(passenger: CheckInPassengerState): string | undefined {
    if (passenger.checkInType === 'LOCKED') return 'Passenger edits are locked.';
    if (passenger.checkInType === 'DEPARTED') return 'This passenger has already departed.';
    return undefined;
}

export function getCheckInDisabledReason(passenger: CheckInPassengerState): string | undefined {
    const timeDisabledReason = getCheckInTimeDisabledReason(passenger);
    if (timeDisabledReason) return timeDisabledReason;
    if (passenger.nodeState === 'RETIRED') return 'Retired passengers cannot be checked in.';
    if (passenger.nodeState === 'FINALIZED') return 'Finalized passengers cannot be checked in.';
    if (passenger.finalizationReasonType && passenger.finalizationReasonType !== 'NONE') {
        return `This passenger has been finalized: ${passenger.finalizationReasonType.replace(/_/g, ' ').toLowerCase()}.`;
    }
    if (isCheckedInPassenger(passenger)) return 'This passenger is already checked in.';
    return undefined;
}

export function canCheckInPassenger(passenger: CheckInPassengerState): boolean {
    return !getCheckInDisabledReason(passenger);
}

export function getCheckInStateUpdate(
    passenger: CheckInPassengerState,
    checkedInTime: string | null | undefined,
    isCheckInAuthorized: boolean
): Pick<PaxNodeInput, 'checkInType' | 'nodeState'> {
    const time = moment(checkedInTime, moment.ISO_8601, true);
    if (!isCheckInAuthorized || !canCheckInPassenger(passenger) ||
        !checkedInTime || !checkedInTime.includes('T') || !time.isValid() || !time.isAfter(moment.utc('1970-01-01T00:00:00Z'))) {
        return {};
    }

    return {checkInType: 'CSR', nodeState: 'CHECKED_IN'};
}
